import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { copyModelsToClipboard ,pasteModelsFromClipboard} from "./modelsclipboard";
import { PathModel } from '../paths/api/generated';
interface Props {
    models: PathModel[];
    setModels: (models: PathModel[]) => void;
}

export const CopyPasteModels = ({ models, setModels }: Props) => {
    const handleCopy = async () => {
        try {
            await copyModelsToClipboard(
                models
                    .filter(
                        (
                            model,
                        ): model is PathModel & {
                            modelId: number;
                            sortOrder: number;
                        } => model.modelId !== undefined && model.sortOrder !== undefined,
                    )
                    .map((model) => ({
                        modelId: model.modelId,
                        sortOrder: model.sortOrder,
                    })),
            );
        } catch (err) {
            console.log('Failed to copy models:', err);
        }
    };

    const handlePaste = async () => {
        try {
            const pastedModels = await pasteModelsFromClipboard();
            setModels(
                pastedModels.map((model) => ({
                    modelId: model.modelId,
                    sortOrder: model.sortOrder,
                })),
            );
        } catch (err) {
            console.log('Failed to paste models:', err);
        }
    };

   return (
    <Stack direction="row" spacing={2}>
      <Button
        variant="contained"
        onClick={handleCopy}
      >
        Copy Models
      </Button>

      <Button
        variant="outlined"
        onClick={handlePaste}
      >
        Paste Models
      </Button>
    </Stack>
  );
};